export default "__VITE_ASSET__54cc5819__"